import { safeParse, safeParseNullDefault } from 'shouldve-been-js';

class ObservationRuleSet {

    private _ruleSetId: string;
    private _name: string;
    private _status: string;

    public constructor(ruleSetId: string, name: string, status: string) {

        this._ruleSetId = ruleSetId;
        this._name = name;
        this._status = status;
    }

    public get ruleSetId(): string {
        return this._ruleSetId;
    }

    public set ruleSetId(value: string) {
        this._ruleSetId = value;
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    public get status(): string {
        return this._status;
    }

    public set status(value: string) {
        this._status = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): ObservationRuleSet | null {

        const rulesetId: string | null = safeParseNullDefault<string>(json?.ruleSetId, '');
        const name: string = safeParse<string>(json?.name, '');
        const status: string | null = safeParseNullDefault<string>(json?.status, '');
        
        if (rulesetId === null || status === null || rulesetId === '') {
            return null;
        }

        return new ObservationRuleSet(rulesetId, name, status);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromIndexedDB(object: any): ObservationRuleSet | null {

        const rulesetId: string | null = safeParseNullDefault<string>(object?._ruleSetId, '');
        const name: string = safeParse<string>(object?._name, '');
        const status: string | null = safeParseNullDefault<string>(object?._status, '');
        
        if (rulesetId === null || status === null || rulesetId === '') {
            return null;
        }

        return new ObservationRuleSet(rulesetId, name, status);
    }
}

export default ObservationRuleSet;